import React from 'react';
import { PDFDownloadLink, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import logo from "Assets/images/logo.png";
import { globalStyles } from "config/pdfStyles";
import { ClientDetailsPdf } from "./Components/ClientDetails";
import { INDIVIDUAL_SESSION_REPORT_QUESTIONS, REPORT_QUESTIONS } from "config/constants";
import RenderAnswer, { RenderAnswerByQId } from "./Components/AnswerFields/Index";
import TherapistSignaturePdf from "./Components/TherapistSignature";
import KhanReportLogoPdf from "./Components/KhanReportLogoPdf";
import { dateFormat, formatString, getAge, wrapTextCustom } from "helpers/common";
import GoalReviewSection from "./Components/GoalReviewSection";
import moment from 'moment';
import GuardianDetailRowPdf from './Components/GuardianDetailRowPdf';
import ReportFooter from "./Components/ReportFooter";

// Create styles
const styles = StyleSheet.create({
  header: {
    alignItems: "center",
    justifyContent: "center"
  },
  logo: {
    width: "20%",
  },
  tableRow: {
    ...globalStyles.tableRow,
    paddingVertical: "10px"
  },
});

export const IndividualSessionReportPdfDoc = ({ data, images, clientType }) => {
  const reportHeading = data?.assesment?.report_heading;
  const reportQuestions = data?.assesmentData?.reportQuestions;
  const reportAnswers = data?.assesmentData?.reportAnswers;
  const assessmentGoals = data?.assesmentData?.reportGoals;

  const caseDiscipline = data?.clientPendingCaseload?.clientCaseloadTherapist?.caseDiscipline;
  const caseTherapist = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "veteran")?.caseTherapist;
  const therapistDetails = { caseDiscipline, caseTherapist }

  return (
    <Document>
      <Page size="A4" style={globalStyles.page}>

        {/* Report Header */}
        <View style={[globalStyles.section, styles.header]}>
          <Image
            style={styles.logo}
            src={logo}
          />
          <Text style={globalStyles.reportHeading}>{reportHeading}</Text>
        </View>
        <View style={globalStyles.section}>

          {/* Client Details */}
          <View style={{ backgroundColor: "#f9f9f9", padding: "5px 10px" }}>
            <View style={globalStyles.table}>

              <View style={styles.tableRow}>
                <Text style={globalStyles.tableHead}>Last Name</Text>
                <Text style={globalStyles.tableColumn}>{data?.lastname}</Text>

                <Text style={globalStyles.tableHead}>First Name</Text>
                <Text style={globalStyles.tableColumn}>{data?.firstname}</Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={globalStyles.tableHead}>Date of Birth:</Text>
                <Text style={globalStyles.tableColumn}>{dateFormat(data?.client_detail?.dob)}</Text>

                <Text style={globalStyles.tableHead}>Age:</Text>
                <Text style={globalStyles.tableColumn}>{getAge(data?.client_detail?.dob)}</Text>
              </View>

              {clientType == "school" && (
                <View style={styles.tableRow}>
                  <Text style={globalStyles.tableHead}>Grade:</Text>
                  <Text style={globalStyles.tableColumn}>{data?.client_detail?.grade}</Text>

                  <Text style={globalStyles.tableHead}>School:</Text>
                  <Text style={globalStyles.tableColumn}>{wrapTextCustom(data?.client_detail?.client_school_detail?.client_school?.name)}</Text>
                </View>
              )}
              <View style={styles.tableRow}>
                <Text style={globalStyles.tableHead}>Report Date:</Text>
                <Text style={globalStyles.tableColumn}>{dateFormat(moment())}</Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={globalStyles.tableColumn}>{formatString(data?.assesment?.assesment_location)}</Text>
                <Text style={globalStyles.tableColumn}></Text>
                <Text style={globalStyles.tableColumn}>Present</Text>
                <Text style={globalStyles.tableColumn}></Text>
              </View>
            </View>

            {/* Guardian Details */}
            {data?.client_detail?.client_guardian_mapping?.length > 0 &&
              data?.client_detail?.client_guardian_mapping?.map(
                (guardian, index) => {
                  const slug = guardian?.client_guardian?.client_role?.slug;
                  if (slug !== (clientType == "school" ? "teacher" : "parent")) {
                    return null;
                  }

                  return (
                    <GuardianDetailRowPdf
                      index={index}
                      guardian={guardian}
                      slug={slug}
                      styles={styles}
                    />
                  );
                }
            )}
          </View>

        </View>

        {/* Questions & Answers */}
        <View style={globalStyles.section}>
          {reportQuestions?.length > 0 &&
            reportQuestions?.map((question, index) => {
              let foundAnswer = reportAnswers?.length && reportAnswers.find(answer => answer.question_id === question.id);
              if (
                [
                  INDIVIDUAL_SESSION_REPORT_QUESTIONS.greeting,
                ].includes(question.id)
              ) {
                return null;
              }

              return (
                <RenderAnswer
                  key={index}
                  question={question}
                  answer={foundAnswer}
                />
              );
            })
          }
        </View>

        {/* Goal Details */}
        <View style={globalStyles.section}>

          <GoalReviewSection
            assessmentGoals={assessmentGoals}
            therapistDetails={therapistDetails}
            showChart={true}
            chartImages={images}
          />

          <RenderAnswerByQId
            questionId={INDIVIDUAL_SESSION_REPORT_QUESTIONS.greeting}
            reportQuestions={reportQuestions}
            reportAnswers={reportAnswers}
            showQuestion={false}
          />

          {/* Therapist Signature */}
          <View style={globalStyles.reportQuestionOuter} wrap={false}>
            <TherapistSignaturePdf
              therapistDetails={therapistDetails}
            />
          </View>

          {/* Branding */}
          <View style={globalStyles.reportQuestionOuter} wrap={false}>
            <KhanReportLogoPdf />
          </View>
        </View>

        <ReportFooter
          data={data}
        />
      </Page>
    </Document>
  )
};
